// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2u2UB","emails":"CreateEditClinics_emails__17mYx","emailTagLabel":"CreateEditClinics_emailTagLabel__judeE"};